import Column from "theme/layouts/Column";
import Grid from "theme/layouts/Grid";
import ModuleMarginWrapper from "theme/components/wrappers/ModuleMarginWrapper";
import React from "react";
import TextStyles from "theme/components/text/TextStyles";
import Youtube from "core-web/components/Youtube";
import { above } from "core-web/utils/mediaqueries";
import styled from "theme/libs/styled";
import useBelowBreakpoint from "core-web/hooks/useBelowBreakpoint";
import { useTranslation } from "react-i18next";

const TextWrapper = styled("div")`
    display: grid;
    gap: 16px;

    ${above.tabletLg} {
        gap: 48px;
    }

    &[data-is-first="true"] {
        grid-template-columns: 1fr;

        ${above.tabletLg} {
            grid-template-columns: 1fr 1fr;
            gap: 48px;
        }
    }
`;

const ProductVideos = ({ youtubeVideos = [] }) => {
    const { t } = useTranslation();
    const isMobile = useBelowBreakpoint("tabletLg");

    if (!youtubeVideos?.length) {
        return null;
    }

    return (
        <ModuleMarginWrapper as="section" marginAfter="lg">
            <TextStyles
                as="h2"
                textStyles={["Myriad Pro/32-120-semibold", null, null, null, "Myriad Pro/40-100-semibold"]}
                mb="24px"
            >
                {t("views.product.headings.video_heading")}
            </TextStyles>

            <Column gap={["48px", null, null, null, "104px"]}>
                {youtubeVideos.map(({ path, name, description }, index) => {
                    const firstVideo = index === 0;

                    // This is needed since the video paths that were imported to Norce are just Video IDs whereas the administrators will most likely insert a full embed url.
                    const isEmbedUrl = path.includes("https://www.youtube.com/embed/");
                    const embedUrl = isEmbedUrl ? path : `https://www.youtube.com/embed/${path}`;

                    return (
                        <Grid
                            key={`${path}-${name}`}
                            columnGap="48px"
                            rowGap="24px"
                            columns={["1", null, null, null, "12"]}
                            height="100%"
                        >
                            <Youtube
                                embedUrl={embedUrl}
                                loading="lazy"
                                showVideoByDefault
                                gridColumn={isMobile || firstVideo ? "1 / -1" : "span 8"}
                                maxWidth="calc(100vw - 40px)"
                            />
                            <TextWrapper
                                data-is-first={firstVideo}
                                gridColumn={isMobile || firstVideo ? "1 / -1" : "span 4"}
                                py={!isMobile && !firstVideo ? "48px" : "0"}
                            >
                                {!!name?.length && (
                                    <TextStyles
                                        as="h3"
                                        textStyles={[
                                            "Myriad Pro/18-120-semibold",
                                            null,
                                            null,
                                            null,
                                            "Myriad Pro/32-120-semibold",
                                        ]}
                                    >
                                        {name}
                                    </TextStyles>
                                )}
                                {!!description?.length && (
                                    <TextStyles textStyles="Myriad Pro/18-140">{description}</TextStyles>
                                )}
                            </TextWrapper>
                        </Grid>
                    );
                })}
            </Column>
        </ModuleMarginWrapper>
    );
};

export default ProductVideos;
